import { Box, Typography } from "@mui/material"

export const RecordingIndicator = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 8,
        left: 8,
        display: 'flex',
        alignItems: 'center',
        background: 'rgba(0,0,0,0.4)',
        borderRadius: 1,
        px: 1,
        py: 0.5,
      }}
    >
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          background: 'red',
          mr: 1,
          boxShadow: '0 0 8px 2px red',
        }}
      />
      <Typography variant="body2" color="error" fontWeight="bold">
        Recording
      </Typography>
    </Box>
  )
}